import Vue from 'vue'

export const getDeepProperty = (obj, path) => path
  .split('.')
  .reduce(
    (obj, prop) => obj && obj[prop] != null ? obj[prop] : undefined,
    obj
  )

export const setDeepProperty = (obj, path, value) => {
  const pathSplit = path.split('.')
  const firstPart = pathSplit.shift()

  if (!obj[firstPart]) obj[firstPart] = {}

  obj[firstPart] = pathSplit.length > 0 ? setDeepProperty(obj[firstPart], pathSplit.join('.'), value) : value

  return obj
}

export const setReactiveDeepProperty = (obj, path, value) => {
  const pathSplit = path.split('.')
  const firstPart = pathSplit.shift()

  if (!obj[firstPart]) obj[firstPart] = {}

  Vue.set(
    obj,
    firstPart,
    pathSplit.length > 0
      ? setReactiveDeepProperty(obj[firstPart], pathSplit.join('.'), value)
      : value
  )
  return obj
}
